// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"8f56630b","258":"b9e257b3","436":"afa401d3","692":"54e5b1f8","881":"92c6492b","897":"cbb89e56"}[chunkId] + ".css";
};